import { RecordSource, RelayFeatureFlags } from 'relay-runtime';
import LiveResolverStore

// @ts-ignore
from 'relay-runtime/lib/store/experimental-live-resolvers/LiveResolverStore';
import RelayDataID from '@atlassian/relay-data-id';
import RelayMissingFieldHandlers from '@atlassian/relay-missing-field-handlers';
import { network as defaultNetwork } from '@atlassian/relay-network';
import RelayScheduler from '@atlassian/relay-scheduler';
var createStore = function createStore(source, options) {
  RelayFeatureFlags.ENABLE_RELAY_RESOLVERS = true;
  return new LiveResolverStore(source, options);
};
export var getDefaultRelayEnvironmentConfig = function getDefaultRelayEnvironmentConfig(_ref) {
  var log = _ref.log,
    requiredFieldLogger = _ref.requiredFieldLogger,
    network = _ref.network;
  return {
    configName: 'Atlassian Graphql Gateway',
    network: network || defaultNetwork,
    store: createStore(new RecordSource(), {
      log: log !== null && log !== void 0 ? log : undefined,
      getDataID: RelayDataID
    }),
    log: log,
    relayFieldLogger: requiredFieldLogger,
    getDataID: RelayDataID,
    scheduler: RelayScheduler,
    missingFieldHandlers: RelayMissingFieldHandlers
  };
};